type Props = {
  color?: string;
  height?: number;
  width?: number;
  className?: string;
};

export default function GiftIcon({
  color = '#000',
  height = 25,
  width = 24,
  className,
}: Props) {
  return (
    <svg
      height={height}
      width={width}
      className={className}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.30887 7C2.80064 6.2847 2.4683 5.46104 2.32807 4.67579C2.1411 3.62877 2.25062 2.47465 2.85869 1.54596C3.49804 0.56951 4.58583 0 6 0C8.37933 0 10.1585 1.20519 11.3087 2.78683C11.5695 3.14542 11.7999 3.5253 12 3.91837C12.2001 3.5253 12.4305 3.14542 12.6913 2.78683C13.8415 1.20519 15.6207 0 18 0C19.4142 0 20.502 0.56951 21.1413 1.54596C21.7494 2.47465 21.8589 3.62877 21.6719 4.67579C21.5317 5.46104 21.1994 6.2847 20.6911 7H22.5C23.3284 7 24 7.67157 24 8.5V13.5C24 14.3284 23.3284 15 22.5 15H21V23.5C21 24.3284 20.3284 25 19.5 25H4.5C3.67157 25 3 24.3284 3 23.5V15H1.5C0.671571 15 0 14.3284 0 13.5V8.5C0 7.67157 0.671573 7 1.5 7H3.30887ZM14.3087 3.96317C13.6556 4.86125 13.2439 5.95694 13.0805 7H17C18.3424 7 19.4412 5.7909 19.7031 4.32421C19.8286 3.62123 19.7194 3.02535 19.4681 2.64154C19.248 2.30549 18.8358 2 18 2C16.3793 2 15.1585 2.79481 14.3087 3.96317ZM10.9195 7C10.7561 5.95694 10.3444 4.86125 9.69126 3.96317C8.84155 2.79481 7.62067 2 6 2C5.16417 2 4.75196 2.30549 4.53193 2.64154C4.28063 3.02535 4.1714 3.62123 4.29693 4.32421C4.55884 5.7909 5.65761 7 7 7H10.9195ZM11 9H2V13H11V9ZM13 9H22V13H13V9ZM5 15V23H11V15H5ZM13 15V23H19V15H13Z"
        fill={color}
      />
    </svg>
  );
}
